import axios from 'axios';
import { expiredSessionPath } from './site';

axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      const token = localStorage.getItem('token');
      localStorage.removeItem('token');
      localStorage.removeItem('name');
      localStorage.removeItem('email');
      localStorage.removeItem('role');
      // Avoid redirect loop if already on login/register
      if (!window.location.pathname.match(/\/(login|register)/)) {
        window.location.href = expiredSessionPath(token); // back to this page after logging in (a finished demo: sign up)
      }
    }
    return Promise.reject(error);
  }
);
